import React, { useState, useEffect, useCallback } from 'react';
import './FlashMessage.css';

const FlashMessage = ({ 
  message, 
  type = 'info', // 'success', 'error', 'warning', 'info'
  duration = 5000, // Auto-dismiss duration in ms (0 = no auto-dismiss)
  onDismiss,
  show = true 
}) => {
  const [isVisible, setIsVisible] = useState(show);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleDismiss = useCallback(() => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      if (onDismiss) {
        onDismiss();
      }
    }, 300); // Match CSS transition duration
  }, [onDismiss]);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsAnimating(true);
      
      // Auto-dismiss after duration
      if (duration > 0) {
        const timer = setTimeout(() => {
          handleDismiss();
        }, duration);
        
        return () => clearTimeout(timer);
      }
    } else {
      handleDismiss();
    }
  }, [show, duration, handleDismiss]);

  if (!isVisible || !message) {
    return null;
  }

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className={`flash-message ${type} ${isAnimating ? 'show' : 'hide'}`}>
      <div className="flash-message-content">
        <span className="flash-message-icon">{getIcon()}</span>
        <span className="flash-message-text">{message}</span>
        <button 
          className="flash-message-close" 
          onClick={handleDismiss}
          aria-label="Close message"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default FlashMessage;
